import { createMemo, Match, Switch, type VoidComponent } from "solid-js";
import { useTranslation } from "../../../../../../state/i18n.tsx";
import SettingSection from "../../../components/SettingSection.tsx";
import {
  ActiveSubscriptionsDto,
  BillingUsageDto,
  SubscriptionStatusDto,
} from "../../../../../../services/BillingService.ts";
import Plan from "./Plan.tsx";

type CurrentPlanSectionProps = {
  billingUsage: BillingUsageDto;
  subscriptionStatus: SubscriptionStatusDto;
  activeSubscriptions: ActiveSubscriptionsDto;
};

const CurrentPlanSection: VoidComponent<CurrentPlanSectionProps> = (props) => {
  const { t } = useTranslation();
  const plan = createMemo(() => props.activeSubscriptions[0]);
  const usage = createMemo(() => props.billingUsage.plans.find((plan) => plan.type === "BASE")!);

  return (
    <SettingSection
      ariaIdPrefix="current-plan"
      title={t(($) => $.SETTINGS_BILLING_CURRENT_PLAN_TITLE)}
      description={t(($) => $.SETTINGS_BILLING_CURRENT_PLAN_DESCRIPTION)}
    >
      <Switch fallback={<Plan status="none" />}>
        <Match when={props.subscriptionStatus.blockedSubscription && !props.subscriptionStatus.unpaidInvoices}>
          <Plan status="blocked" planName={plan().name} interval={plan().interval} />
        </Match>
        <Match when={props.subscriptionStatus?.unpaidInvoices}>
          <Plan status="unpaid" planName={plan().name} interval={plan().interval} />
        </Match>
        <Match when={props.subscriptionStatus?.pastDueInvoices}>
          <Plan status="pastDue" planName={plan().name} interval={plan().interval} />
        </Match>
        <Match when={props.subscriptionStatus?.trialing && !props.subscriptionStatus?.trialExceeded}>
          <Plan status="trial" planName={plan().name} interval={plan().interval} cycleEnd={usage().cycle.end} />
        </Match>
        <Match when={props.subscriptionStatus.activeSubscription}>
          <Plan status="active" planName={plan().name} interval={plan().interval} cycleEnd={usage().cycle.end} />
        </Match>
      </Switch>
    </SettingSection>
  );
};

export default CurrentPlanSection;
